import React from "react";
import { useNavigate } from "react-router-dom"; // 🔹 Add this at the top 
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/system";
import studentDB from "../assets/Clothing.jpeg";
import inventoryDB from "../assets/Food.jpeg";
import hospitalDB from "../assets/Coaching.jpeg";

// Page Wrapper with White Background
const Section = styled("section")({
  background: "#FFFFFF",
  minHeight: "115vh",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 20px",
  position: "relative",
});

// Gradient Container (Moved Up)
const GradientContainer = styled(Container)({
  background: "linear-gradient(to right, #00c9a7, #0072ff)",
  padding: "40px",
  borderRadius: "20px",
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
  maxWidth: "800px",
  textAlign: "center",
  position: "relative", // Moves container upward
  marginBottom: "55px",
});


const Marketing = () => {
    const navigate = useNavigate();
  return (
    <Section>
      {/* UI/UX Design Main Section */}
      <GradientContainer>
        <Typography variant="h2" sx={{ fontWeight: "bold", color: "#FBFFFE" }}>
          Marketing
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2, color: "#FBFFFE" }}>
        We're offering a complimentary 1-month marketing package,
        that will help elevate your brand's visibility and reach.
        </Typography>
        <Box sx={{ marginTop: 3 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FAA916",
              color: "#FBFFFE",
              "&:hover": { backgroundColor: "#e08c00" },
            }}
            onClick={() => navigate("/contact")} // 🔹 Navigate to contact.js
          >
            Get Started
          </Button>
        </Box>
      </GradientContainer>

      {/* Recommended Projects Section */}
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", marginBottom: 4, color: "#333" }}
      >
        Recommended Marketing
      </Typography>

      <Grid container spacing={4} justifyContent="center" width="100%">
        {/* Project 1 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={studentDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Local Fashion Boutique / Clothing Brand
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                Instagram page setup & reels banakar followers badhwana, Monthly catalog designing, WhatsApp marketing campaigns, Influencer collaboration plan.              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={inventoryDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Café or Food Truck
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                Google Business listing optimization, Menu design + creative reels (food photography), “Buy 1 Get 1” type offers ka campaign, Zomato/Swiggy listing help.             </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 3 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={hospitalDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Online Coaching Institute / Tuition Classes
              </Typography>
              <Typography variant="body2" color="text.secondary">
              Lead generation (Facebook/Instagram Ads), Demo session ke liye form filling landing page, Testimonial reels + student feedback campaigns, Email/SMS reminder automation.             </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Section>
  );
};

export default Marketing;
